import { Base64 } from "js-base64";
import isEmpty from "lodash/isEmpty";
// import { message, Modal } from "antd";
import WindowFunc from "./window";
window.E9Encrypt = false;
import { getLabel } from "../wea-locale-provider/util";

// fetch 部分处理
const server = window.server || "";
export const getFd = (values, deep) => {
  let fd = "";
  for (let p in values) {
    let target = values[p];
    if (typeof target === "function") {
      continue;
    }
    if (deep && typeof target === "object") {
      fd += getFd(target, deep);
    } else if (p == "jsonstr" && typeof target === "object") {
      let item = JSON.stringify(target);
      fd += p + "=" + item.replace(/\\/g, "") + "&";
    } else {
      // 处理undefined null数据to 空串
      target = target == undefined ? "" : target;
      let item = encodeURIComponent(target);
      fd += p + "=" + item + "&";
    }
  }
  return fd;
};

// 获取页面CRSF code
export const getPageCheckCode = ({ key, code }) => {
  window.pageCheckKey = key;
  window.pageCheckCode = code;
};

const getFetchParams = (method, params, deep, noInclude) => {
  let obj = {
    method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest"
    }
  };
  if (server == "" && !noInclude) {
    obj.credentials = "include";
  }
  if (!isEmpty(params) && method.toUpperCase() !== "GET") {
    obj.body = getFd(params, deep);
  }
  return obj;
};

const handleRejct = msg => {
  if (window.frameElement) {
    let url = window.frameElement.src;
    if (/.*index-emobile\.html.*/.test(url)) {
      if (em && em.checkJsApi("pageReload")) {
        em.pageReload({});
      }
      return true;
    }
    if (/.*index-message\.html.*/.test(url)) {
      if (em && em.checkJsApi("pageReload")) {
        em.pageReload({});
      }
      return true;
    }
    if (/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(url)) {
      if (em && em.checkJsApi("pageReload")) {
        em.pageReload({});
      }
      return true;
    }
  }
  if (
    /.*\/login\/OALogin\.jsp.*/.test(WindowFunc.getTop().location.href) ||
    /.*\/wui\/index\.html.*#\/\?.*/.test(WindowFunc.getTop().location.href) ||
    /.*\/wui\/index\.html$/.test(WindowFunc.getTop().location.href)
  ) {
    return true;
  }
  if (
    !/.*index-emobile\.html.*/.test(WindowFunc.getTop().location.href) &&
    !/.*index-message\.html.*/.test(WindowFunc.getTop().location.href) &&
    !/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(
      WindowFunc.getTop().location.href
    )
  ) {
    window.antd && antd.message.error(msg);
    setTimeout(() => {
      try {
        if (WindowFunc.getTop().opener && WindowFunc.getTop().opener.ecCom) {
          WindowFunc.getTop().opener.location.href =
            "/wui/index.html?v=" + new Date().getTime();
        }
      } catch (error) {}
      window.localStorage["gopage"] = encodeURIComponent(location.href);
      WindowFunc.getTop().location.href =
        "/wui/index.html?v=" + new Date().getTime();
    }, 1000);
  } else {
    if (window.em) {
      window.em.getEmAuthCode({
        sysId: window.localStorage.emobile_ec_id, // 集成系统ID
        success: emres => {
          // 如：{"em_auth_code":"abc123","errMsg":"getEmAuthCode:ok"}
          if (emres.em_auth_code) {
            callApi("/api/ec/dev/app/test", "GET", {
              em_auth_code: emres.em_auth_code
            }).then(
              res => {
                if (res.status === true || res.status === "1") {
                  window.location.reload();
                } else {
                  console && console.error("认证失败，" + res.errmsg);
                }
              },
              () => {
                console &&
                  console.error("认证失败，code：" + emres.em_auth_code);
              }
            );
          } else {
            console && console.error("获取em_auth_code失败");
          }
        }
      });
    } else {
      console && console.error("em对象不存在");
    }
  }
  return true;
};

const checkReject = obj => {
  if (obj.columns && window.localStorage.getItem("hackResponse")) {
    obj.errorCode = "005";
  }
  let isFalse = false;
  if (obj.errorCode && obj.errorCode === "001") {
    // session异常，如果有路由就强制跳转
    isFalse = handleRejct(getLabel("516531", "session过期，请重新登录！"));
  } else if (obj.errorCode && obj.errorCode === "002") {
    // session异常，如果有路由就强制跳转
    isFalse = handleRejct(getLabel("516532", "登录超时，请重新登录！"));
  } else if (obj.errorCode && obj.errorCode === "003") {
    // session异常，如果有路由就强制跳转
    isFalse = handleRejct(getLabel("81908", "您已被管理员强制下线！"));
  } else if (obj.errorCode && obj.errorCode === "004") {
    // session异常，如果有路由就强制跳转
    isFalse = handleRejct(
      getLabel("23274", "您已经从另一个窗口登入，当前工作窗口失效！")
    );
  } else if (obj.errorCode && obj.errorCode === "005") {
    window.antd && antd.message.error(obj.error || obj.msg);
    // setTimeout(() => window.location.reload(), 1000);
    isFalse = true;
  } else if (
    typeof obj.status !== "undefined" &&
    (!obj.status || obj.status === "false")
  ) {
    // window.antd && antd.message.error('接口业务逻辑错误：' + obj.error, 5);
    if (obj.error || obj.msg) {
      !/.*index-emobile\.html.*/.test(WindowFunc.getTop().location.href) &&
        !/.*index-message\.html.*/.test(WindowFunc.getTop().location.href) &&
        !/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(
          WindowFunc.getTop().location.href
        ) &&
        window.antd &&
        antd.message.error(obj.error || obj.msg);
    }
    isFalse = true;
  }
  return isFalse;
};

const checkCSRF = (url, method, _params, type, deep, check = true) => {
  if (!check) {
    return callApi(url, method, params, type, deep, false);
  }
  let params =
    Object.prototype.toString.call(_params) === "[object Object]"
      ? { ..._params }
      : {};
  if (Object.prototype.toString.call(_params) === "[object Array]") {
    params = [..._params];
  }
  if (window.pageCheckKey && window.pageCheckCode) {
    // 单独处理表单一个页面唯一code
    params[window.pageCheckKey] = window.pageCheckCode;
    params["__randCodeKey__"] = window.pageCheckKey;
    return callApi(url, method, params, type, deep, false);
  }
  return callApi("/api/security/getRandomCode", "get", {}, "json", false, false)
    .then(res => {
      params[res.key] = res.code;
      params["__randCodeKey__"] = res.key;
      return callApi(url, method, params, type, deep, false);
    })
    .catch(err => {
      console.log(err);
      window.checkCSRF = false;
      return callApi(url, method, params, type, deep, false);
    });
};
export const callApi = (
  url,
  method = "GET",
  _params = {},
  type = "json",
  deep = false,
  checkCode = true
) => {
  let params =
    Object.prototype.toString.call(_params) === "[object Object]"
      ? { ..._params }
      : {};
  if (Object.prototype.toString.call(_params) === "[object Array]") {
    params = [..._params];
  }
  if (
    typeof localStorage.access_token === "string" &&
    localStorage.access_token !== ""
  ) {
    params.access_token = localStorage.access_token;
  }
  if (
    window.checkCSRF === true &&
    checkCode &&
    window.sessionStorage["em_check_csrf"] == "true" &&
    // method.toUpperCase() === "POST" &&
    /^\/api/.test(url)
  ) {
    return checkCSRF(url, method, _params, type, deep);
  }
  url = `${server}${url}`;
  if (window.ecCallApiLogServer && url == "/api/securtity/addListUrlLog") {
    url = `${window.ecCallApiLogServer}${url}`;
  }
  if (method.toUpperCase() === "GET" && !isEmpty(params)) {
    let c = "?";
    if (/\?/.test(url)) c = "&";
    url = `${url}${c}${getFd(params)}`;
  }
  if (method.toUpperCase() === "GET" && !/__random__=/.test(url)) {
    let c = "?";
    if (/\?/.test(url)) c = "&";
    url += c + "__random__=" + new Date().getTime();
  }
  // 处理连续&
  url = url.replace(/\&\&/g, "&");

  function evil(fn) {
    var Fn = window.Function; //一个变量指向Function，防止有些前端编译工具报错
    return new Fn("return " + fn)();
  }

  return new Promise((resolve, reject) => {
    let validateParams = JSON.stringify(_params);
    if (validateParams.indexOf("base64_") > -1) {
      console && console.warn("原不能提交数据：", _params);
      // regex
      const regexBase = /base64_(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?/g;
      if (regexBase.test(validateParams)) {
        params = validateParams.replace(regexBase, oldStr => {
          return Base64.decode(oldStr.substr(7));
        });
        console && console.warn("后转换成功的数据", JSON.parse(params));
      }
      if (params.indexOf("base64_") > -1) {
        reject(getLabel("516533", "base64 不能提交:"));
      } else {
        params = JSON.parse(params);
      }
    }
    let _url = url;
    let _fetchParams = getFetchParams(
      method,
      params,
      deep,
      window.ecCallApiLog ? true : false
    );
    if (
      window.e9ssoPCConfig &&
      window.e9ssoPCConfig.inUse &&
      window.e9ssoPCConfig.callapi_params_handler
    ) {
      let res = window.e9ssoPCConfig.callapi_params_handler(
        _url,
        method,
        params,
        type,
        _fetchParams
      );
      _url = res.url;
      method = res.method;
      params = res.params;
      type = res.type;
      _fetchParams =
        res.fetchParams ||
        getFetchParams(
          method,
          params,
          deep,
          window.ecCallApiLog ? true : false
        );
    }
    if (window.ecCallApiLog) {
      var logParams = {};
      logParams._url = _url;
      logParams.method = method;
      logParams.params = params;
      logParams.type = type;
      logParams._fetchParams = _fetchParams;
      logParams.themeAccount = localStorage["theme-account"];
      logParams.href = window.location.href;
      logParams.calldatetime = new Date();
    }
    fetch(_url, _fetchParams)
      .then(function(response) {
        if (window.ecCallApiLog) {
          logParams.response = response.clone();
          logParams.endtime = new Date();
          window.ecCallApiLog(logParams);
        }
        if (!response.ok) {
          if (window.ecCallApiHandler) {
            if (typeof window.ecCallApiHandler == "function") {
              window.ecCallApiHandler(
                _url,
                params,
                response.status,
                response.statusText
              );
            }
          }
          return Promise.reject({
            status: response.status,
            statusText: response.statusText
          });
        }
        return response.text().then(data => {
          if (
            window.e9ssoPCConfig &&
            window.e9ssoPCConfig.inUse &&
            window.e9ssoPCConfig.callapi_response_handler
          ) {
            return window.e9ssoPCConfig.callapi_response_handler(
              data,
              reject,
              response,
              type
            );
          }
          if (response.redirected && /\/login\/Login.jsp/.test(response.url)) {
            if (
              /.*\/wui\/index\.html#\/?.*/.test(
                WindowFunc.getTop().location.href
              ) ||
              /.*\/wui\/index\.html$/.test(WindowFunc.getTop().location.href)
            ) {
              return { status: true };
            }
            if (
              /.*index-emobile\.html.*/.test(
                WindowFunc.getTop().location.href
              ) ||
              /.*index-message\.html.*/.test(
                WindowFunc.getTop().location.href
              ) ||
              /.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(
                WindowFunc.getTop().location.href
              )
            ) {
              if (window.em) {
                em.setPageReload({
                  setvalue: 1, // 1表示每次都需要重新加载页面（默认） 2表示保持页面无需重新加载，
                  success: function(res) {
                    // 如：{"errMsg":"setHoldPage:ok"}
                    //alert(res.errMsg);
                  }
                });
              }
              return { status: false, errorCode: "002" };
            }
            if (window.frameElement) {
              let url = window.frameElement.src;
              if (
                /.*index-emobile\.html.*/.test(url) ||
                /.*index-message\.html.*/.test(url) ||
                /.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(url)
              ) {
                if (window.em) {
                  em.setPageReload({
                    setvalue: 1, // 1表示每次都需要重新加载页面（默认） 2表示保持页面无需重新加载，
                    success: function(res) {
                      // 如：{"errMsg":"setHoldPage:ok"}
                      //alert(res.errMsg);
                    }
                  });
                }
                return { status: false, errorCode: "002" };
              }
            }
            window.antd &&
              antd.message.error(getLabel("516532", "登录超时，请重新登录！"));
            console && console.error(`${url} fetch 登录超时`);
            setTimeout(() => {
              window.localStorage["gopage"] = encodeURIComponent(location.href);
              WindowFunc.getTop().location.href =
                "/wui/index.html?v=" + new Date().getTime();
            }, 1000);
          }
          if (type === "json") {
            try {
              var dataTemp = JSON.parse(data);
              if (dataTemp.needResponse) {
                dataTemp.response = response;
              }
              return dataTemp;
            } catch (error) {
              data = data || "{}";
              return evil("(" + data + ")"); // JSON.parse 解析反斜杠报错处理
            }
          } else {
            return data;
          }
        });
      })
      .then(data => {
        if (window.rewriteApiData) {
          data = window.rewriteApiData(_url, params, data);
        }

        //weaHistory
        if (
          type === "json" &&
          data &&
          (data.status === "false" || !data.status) &&
          data.showType === "url" &&
          data.url
        ) {
          setTimeout(
            () => (WindowFunc.getTop().location.href = data.url),
            1000
          );
          resolve(data);
        } else if (
          type === "json" &&
          data &&
          (data.status === "false" || !data.status) &&
          data.showType === "auth"
        ) {
          if (window.weaHistory) {
            let pathname = "/main/com/auth";
            if (
              WindowFunc.getTop().location.href.indexOf("/wui/engine.html") > -1
            ) {
              pathname = "/com/auth";
            }
            window.weaHistory.push({
              pathname: pathname
            });
          }

          resolve(data);
        } else if (
          type === "json" &&
          data &&
          (data.status === "false" || !data.status) &&
          (data.showMsg || data.showType === "msg")
        ) {
          data.error && window.antd && antd.message.warn(data.error);
          resolve(data);
        } else if (
          type === "json" &&
          data &&
          (data.status === "false" || !data.status) &&
          data.showType === "none"
        ) {
          resolve(data);
        } else if (
          type === "json" &&
          data &&
          (data.status === "false" || !data.status) &&
          (data.showModal || data.showType === "modal")
        ) {
          data.error &&
            window.antd &&
            antd.Modal.warning({
              title: data.title || getLabel("19085", "消息提醒"),
              content: data.error
            });
          resolve(data);
        } else if (type === "json" && checkReject(data)) {
          console &&
            console.error(`${url} fetch 请求异常: ${data.error || "error"}`);
          if (/\/api\/ecode\/sync/.test(url)) {
            resolve({ status: true });
          }
          reject(`${url} fetch 请求异常: ${data.error || "error"}`);
        } else {
          resolve(data);
        }
      })
      .catch(function(ex) {
        if (window.ecCallApiHandler) {
          if (typeof window.ecCallApiHandler == "function") {
            window.ecCallApiHandler(_url, params, ex.status, ex.statusText);
          }
        }
        console &&
          console.error(`${url} fetch 数据处理异常: ${ex}, params:`, params);
        reject({
          msg: `${url} fetch 数据处理异常: ${ex}`,
          responseCode: ex.status,
          statusText: ex.statusText
        });
      });
  });
};

if (window.sessionStorage["em_check_csrf"] === undefined) {
  callApi("/api/security/isEnableRandomCode")
    .then(res => {
      if (res.randomCodeStatus == true) {
        window.checkCSRF = true;
        window.sessionStorage["em_check_csrf"] = "true";
      }
    })
    .catch(error => {
      console && console.log("check csrf toggle fail", error);
      window.sessionStorage["em_check_csrf"] = "false";
    });
} else {
  if (window.sessionStorage["em_check_csrf"] == "true") {
    window.checkCSRF = true;
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-tools/callApi.js